export enum FleetUUIDs {
  ACTransit = '872a8e92-54b5-47b3-90a3-1210ab274d97',
  Barcelona = 'b2d1a097-8e9b-4655-abff-1bcb5c91c898',
  Chicago = 'd5bddb6e-68b2-40bf-a617-e3313120de14',
  ChicagoCDOF = 'ac8fb65e-35a2-4676-8d06-d3c03fa63da7',
  CulverCity = '2fb84e12-d339-481d-aa68-69bc83310cd3',
  WMATA = 'e11cc71c-c921-4451-bdf1-2413782adf7a',
  MTA = '4e9c24c6-489f-4f2c-9f10-5ab265c2e3d2',
  MTAReplay = '0ab4225c-da2f-4626-b25c-0f6589fc9fd3',
  MBTA = 'dc65d8cf-4f62-4b59-8a4f-909f9fc9d532',
  MBTAPrePilot = 'c4924bf4-3244-44f2-ba73-563bdf1800e6',
  SacRTBusStopShelter = 'c2170fe9-d566-4e6b-a5d0-1a097d7b24fa',
  SacRTBusStopShelterActivePilot = '0ecade16-4ca5-41ab-9d31-e6d751104168',
  Sacramento = 'e4188ed7-63f3-4d5c-95ed-984136e4cecc',
  VanTesting = 'e64ba1c4-adb4-45b0-b351-180710e6cc67',
  PPA = '46fc661c-52f2-4e2e-9088-37078c72f01b',
  AthensEuPilotEnv = '7e56d73b-7661-45d9-afe8-04c41aef4d52',
  AthensEuProdEnv = 'e30e3701-a3fa-49fb-b972-3aa2c3ec0dd2',
  SantaMonica = '20936353-b1d0-4e30-b9e9-186aeb352781',
  TFL = 'ef216175-963e-4e60-ba50-15be1fc2c7c0',
  TFLStaging = '24af496b-87ce-4f64-880f-ea0faba5c862',
}
